import { Typography } from '@mui/material'
import { i18WithParams as t } from '@shared/locale'
import { Spacer } from 'components-ui/src/spacer/spacer'

type VerificationModalTitleType = {
  variant: 'REGISTERING' | 'EXISTING_USER' | 'DEFAULT'
  email?: string
}

export const VerificationModalTitle = ({ variant = 'DEFAULT', email = '' }: VerificationModalTitleType) => {
  switch (variant) {
    case 'REGISTERING':
      return (
        <>
          <Typography variant="h6">{t('forcedLogin.register.title')}</Typography>
          <Spacer height={3} />
          <Typography variant="body1">{t('forcedLogin.register.info', { email })}</Typography>
          <Spacer height={1} />
        </>
      )
    case 'EXISTING_USER':
      return (
        <>
          <Typography variant="h6">{t('forcedLogin.existingUser.title')}</Typography>
          <Spacer height={3} />
          <Typography variant="body1">{t('forcedLogin.existingUser.info')}</Typography>
          <Spacer height={1} />
        </>
      )
    default:
      return (
        <>
          <Typography variant="h6">{t('forcedLogin.enterEmail')}</Typography>
          <Spacer height={3} />
          <Typography variant="body1">{t('forcedLogin.text')}</Typography>
          <Spacer height={1} />
        </>
      )
  }
}
